import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, withCtx as _withCtx, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "_mt-1" }
const _hoisted_2 = { class: "gfu-hd gfu-hd--h3" }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_base_icon = _resolveComponent("base-icon")
  const _component_tooltip = _resolveComponent("tooltip")
  const _component_project_summary_clock = _resolveComponent("project-summary-clock")
  const _component_project_promo_item = _resolveComponent("project-promo-item")
  const _component_project_summary_follow = _resolveComponent("project-summary-follow")
  const _component_social_media_actions = _resolveComponent("social-media-actions")
  const _component_project_summary_box = _resolveComponent("project-summary-box")

  return (_openBlock(), _createBlock(_component_project_summary_box, { "data-qa": "project-summary-box:Draft" }, {
    header: _withCtx(() => [
      _createElementVNode("div", null, [
        _createVNode(_component_base_icon, {
          name: "brand-outline",
          "icon-namespace": "ga",
          size: "2x",
          class: "_tc--accent"
        }),
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("h4", _hoisted_2, [
            _createTextVNode(_toDisplayString(_ctx.Resources.ProjectHome.CrowdfundingDraftInfoTitle) + " ", 1 /* TEXT */),
            _createVNode(_component_tooltip, {
              text: _ctx.Resources.ProjectHome.ProjectSummaryBoxDraftInfoTooltip
            }, {
              default: _withCtx(() => [
                _createVNode(_component_base_icon, {
                  name: "circle-info",
                  class: "gfu-countdown__tooltip"
                })
              ]),
              _: 1 /* STABLE */
            }, 8 /* PROPS */, ["text"])
          ])
        ])
      ]),
      ($props.campaignStartDate)
        ? (_openBlock(), _createBlock(_component_project_summary_clock, {
            key: 0,
            "elapsed-message": _ctx.Resources.ProjectHome.ProjectSummaryBoxDraftCountdownElapsed,
            "target-date": $props.campaignStartDate,
            title: _ctx.Resources.ProjectHome.ProjectSummaryBoxDraftCountdownTitle,
            class: "_mt-3"
          }, null, 8 /* PROPS */, ["elapsed-message", "target-date", "title"]))
        : _createCommentVNode("v-if", true),
      (_ctx.promoItem)
        ? (_openBlock(), _createBlock(_component_project_promo_item, {
            key: 1,
            class: "gfu-project-summary-promo-item",
            "data-qa": `project-summary-promo-item:${_ctx.promoItem.type}`
          }, null, 8 /* PROPS */, ["data-qa"]))
        : _createCommentVNode("v-if", true)
    ]),
    actions: _withCtx(() => [
      _createVNode(_component_project_summary_follow),
      _createVNode(_component_social_media_actions, { class: "_mt-3 _tac" })
    ]),
    _: 1 /* STABLE */
  }))
}